@if (canExportExcel()) {
  <p-button
    [label]="'travelBoards.export' | transloco"
    icon="pi pi-upload"
    [outlined]="true"
    (onClick)="showExportModal = true"
  />
} @else {
  <app-locked-button
    [label]="'travelBoards.export' | transloco"
    [limitedFeature]="xlsFeature"
  />
}
<app-export-modal [(visible)]="showExportModal" />
